import axios from 'config/axios'

const fetcher = async (url) => {
  try {
    return await axios.get(url).then((res) => res.data)
  } catch (err) {
    const error = new Error('An error occurred while fetching the data.')
    error.info = err?.response?.data
    error.status = err.status
    throw error
  }
}

export default fetcher
